module.exports = __webpack_public_path__ + "static/media/stars.c2353ecb.svg";